import React, { useEffect } from "react";
import { fetch } from "../../actions";
import { connect } from "react-redux";
import { ModalPadrao, InputPadrao, LabelPadrao, LoadingContainerPadrao, BoxIcon } from "../../components/Base";
import { Input, Tooltip } from "antd";
import { useFetch } from "../../components/Hooks/Conexao";
import TabelaPadrao from "../../components/TabelaPadrao";
import { BtnSair } from "../../components/Buttons";
import culture from "../../Utils/Culture";

function ConsultaEstoque({ visible, onCancel, id, ...props }) {
  const [dados, listarDados, loadingDados] = useFetch(null, { prod: {}, estoque: [] });

  useEffect(() => {
    if (id && visible)
      listarDados(() => props.fetch().post(`/estoque/prodest/${id}`));
    else
      onCancel();
  }, [visible]);

  return <ModalPadrao visible={visible} onCancel={onCancel} width={window.innerWidth < 500 ? window.innerWidth : 500} footer={null} title="Consulta Estoque/Observação">
    <LoadingContainerPadrao loading={loadingDados} spinnerProps={{ fontSize: 60, marginTop: 20 }}>
      <div>
        <div><LabelPadrao noMargin>Produto</LabelPadrao></div>
        <InputPadrao value={dados.prod.descricao} disabled />
      </div>
      <LabelPadrao>Observação</LabelPadrao>
      <Input.TextArea value={dados.prod.obs} disabled />

      <TabelaPadrao columns={columns} data={dados.qtd} style={{ marginTop: 25 }} checkOnlyOne />
      <div style={{ textAlign: 'right', marginTop: 15 }}>
        <BtnSair onClick={onCancel} />
      </div>
    </LoadingContainerPadrao>
  </ModalPadrao>;
}

export default connect(null, { fetch })(ConsultaEstoque);

const columns = [
  {
    Header: "Empresa",
    accessor: "razaoSocial",
    Cell: props => <span style={{ display: "flex", alignItems: "center" }}>{props.row.original.razaoSocial} {!!props.row.original.lotes.length && <Tooltip
      title={props.row.original.lotes.map(x => <p style={{ margin: 0, padding: 0 }} key={x.lote}>{x.lote} - {culture.format(x.quantidade)}</p>)} placement="bottom">
      <BoxIcon className="row-verde" style={{ fontSize: 15, marginLeft: 10 }} />
    </Tooltip>}</span>
  },
  {
    Header: "Reserva",
    accessor: "reserva",
    tipo: "dec",
  },
  {
    Header: "Estoque Atual",
    accessor: "estoque",
    tipo: "dec",
  },
];
